import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ChangeEventHandler, FC, useCallback } from 'react';
import { useLoading, useSearchParameters, useSetSearchParameters, useTotalWorks } from './context';
import styles from './work.module.scss';

export const WorksPagination: FC = () => {
  const search = useSearchParameters();
  const setSearch = useSetSearchParameters();
  const total = useTotalWorks();
  const loading = useLoading();

  const pages = Math.ceil(total / search.limit);

  const next = Math.min(total - search.page * search.limit, search.limit);

  const onClickNext = useCallback(() => {
    if (search.page + 1 > pages) {
      return;
    }
    setSearch({ ...search, page: search.page + 1 });
  }, [search, setSearch, pages]);

  const onClickPrev = useCallback(() => {
    if (search.page <= 1) {
      return;
    }
    setSearch({ ...search, page: search.page - 1 });
  }, [search, setSearch]);

  const changePage = useCallback<ChangeEventHandler<HTMLSelectElement>>(
    (evt) => {
      const p = parseInt(evt.target.value, 10);
      setSearch({ ...search, page: p });
    },
    [search, setSearch],
  );

  const arr = new Array(pages).fill(0).map((_, i) => i + 1);

  return (
    <div className={styles.pagination} aria-hidden={total === 0}>
      {search.page < pages && (
        <button type='button' className={styles.paginationNext} onClick={onClickNext} disabled={loading}>
          次の{next}件を見る
          <FontAwesomeIcon className={styles.paginationNextChevron} icon={faChevronRight} />
        </button>
      )}
      <div className={styles.paginationControls}>
        <button
          type='button'
          className={styles.paginationButton}
          onClick={onClickPrev}
          disabled={search.page <= 1 || loading}
        >
          前
        </button>
        <select className={styles.paginationSelect} value={search.page} onChange={changePage} disabled={loading}>
          {arr.map((p) => (
            <option key={p} value={p}>
              {p} / {pages}
            </option>
          ))}
        </select>
        <button
          type='button'
          className={styles.paginationButton}
          onClick={onClickNext}
          disabled={search.page >= pages || loading}
        >
          次
        </button>
      </div>
    </div>
  );
};
